"use client"
import { SignUpData, User } from '@repo/ui/lib/api/types/auth';
import { AxiosInstance } from 'axios';
import { jwtDecode } from 'jwt-decode';
import { safeGetItem, safeRemoveItem, safeClear } from '../../utils/localStorage';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';

export class AuthService {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance = axiosInstance) {
    this.axios = axios;
  }

  static getCurrentUser(): string | null {
    return safeGetItem('token');
  }

  static getDecodedToken(): User | null {
    const token = AuthService.getCurrentUser();
    if (!token) return null;
    try {
      return jwtDecode(token);
    } catch (error) {
      safeClear();
      return null;
    }
  }
  static getRole(): string | null {
    const decoded = AuthService.getDecodedToken();
    return decoded?.role ?? null;
  }


  public isAdmin(): boolean {
    try {
      const decoded = AuthService.getDecodedToken();
      if (!decoded) return false;
      return decoded?.role === 'ADMIN';
    } catch (error) {
      safeClear();
      return false;
    }
  }

  public isVisiteur(): boolean {
    const decoded = AuthService.getDecodedToken();
    if (!decoded) return false;
    return decoded?.role?.toUpperCase() === 'VISITEUR';
  }

  public isDendro(): boolean {
    try {
      const decoded = AuthService.getDecodedToken();
    if (!decoded) return false;
      return decoded?.groupe === 'DENDROMAP';
    } catch (error) {
      safeClear();
      return false;
    }
  }

  public isAgile(): boolean {
    const decoded = AuthService.getDecodedToken();
    if (!decoded) return false;
    return decoded?.forfait !== 'AGILE';
  }

  public isAgent(): boolean {
     try {
      const decoded = AuthService.getDecodedToken();
      if (!decoded) return false;
      return decoded?.role.toUpperCase() === 'AGENT';
    } catch (error) {
      safeClear();
      return false;
    }
  }

  public isRoleDeleted(): boolean {
    return !this.isAgent() && !this.isVisiteur();
  }

  logout(): void {
    safeRemoveItem('token');
  }

  async resetPassword(token: string, password: string, confirmPassword: string) {
    return this.axios.post(ENDPOINTS.AUTH.RESET_PASSWORD, {
      token,
      password,
      confirmPassword,
    });
  }

  async confirmEmail(token: string) {
    return this.axios.post(ENDPOINTS.AUTH.CONFIRM_EMAIL, { token });
  }

  async sendEmailResetPassword(email: string) {
    return this.axios.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
  }

  async resendVerificationEmail(email: string) {
    return this.axios.post<{ success: boolean; message: string }>(
      ENDPOINTS.AUTH.RESEND_VERIFICATION,
      { email },
    );
  }

  async verifyToken(token: string) {
    return this.axios.post(ENDPOINTS.AUTH.VERIFY_TOKEN, { token });
  }

  async login(email: string, password: string) {
    const response = await this.axios.post(ENDPOINTS.AUTH.LOGIN, { email, password });
    return response
  }

  async signUp(data: SignUpData) {
    return this.axios.post(ENDPOINTS.AUTH.SIGNUP, data);
  }

  async demo(payload: { email: string; nom?: string; prenom?: string; planType?: 'BASIC' | 'ADVANCED'; password?: string; tierId?: string }) {
    return this.axios.post(ENDPOINTS.AUTH.BASE + '/demo', payload);
  }
}
